import { connect } from 'react-redux'
import React, { useState, useEffect } from 'react'
import { t } from 'ttag'

import Field from '../../../form/Field'
import { suggestMajorsFromInput } from '../../../../actions/search'

const MajorSuggestField = ({
  searchFilterFormName,
  majorSuggestions,
  filter,
  form,
  dispatch
}) => {
  const [selected, setSelected] = useState([])

  useEffect(() => {
    if (filter.isApplied) {
      setSelected(filter.value)
    }
  }, [filter.isApplied, filter.value])

  return (
    <Field
      model={`${searchFilterFormName}.${filter.id}`}
      form={form}
      largeTextInput={true}
      theme="bootstrap3"
      label={t`Major`}
      type="MultiSelect"
      options={majorSuggestions}
      onSearchChange={term => dispatch(suggestMajorsFromInput(term))}
      onChange={selections => {
        setSelected(selections)
      }}
      createFromValue={() => {
        return selected.map(value => {
          return { label: value.name || 'unknown', value }
        })
      }}>
    </Field>
  )
}

export default connect(
  state => {
    /*
     *occupationSuggestionsRequest: restReducer(SEARCH_SUGGEST_OCCUPATION),
     *majorSuggestionsRequest: restReducer(SEARCH_SUGGEST_MAJOR),
     *collegeSuggestionsRequest: restReducer(SEARCH_SUGGEST_COLLEGE),
     */
    const majorSuggestions = state.search.majorSuggestionsRequest.result?.map(major => {
      return {
        label: major.label,
        value: {
          name: major.label,
          cipCode: major.value
        }
      }
    })

    //console.log(state.occupations)
    return {
      majorSuggestions
    }
  },
  dispatch => ({
    dispatch
  })
)(MajorSuggestField)
